import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Chip,
  Box,
} from "@material-ui/core";
import FiberNewIcon from "@material-ui/icons/FiberNew";

import { resolveNoveltyEntry } from "./noveltyResolve";
import { markSeen } from "../../../services/changelogSeenStorage";

const TIPO_LABEL = { new: "Nuevo", improvement: "Mejora", fix: "Corrección" };
const TIPO_COLOR = { new: "primary", improvement: "default", fix: "default" };

// Control accesible con la novedad de esta sección: si hay algo reciente y
// sin ver para alguno de los "anchors" dados, muestra un botón con ícono +
// Tooltip de hover (como ya hace ConfigSectionInfo al lado) que abre un
// Dialog con el resumen y el link permanente al changelog completo. Al
// abrirse se marca como "visto" — onSeen (opcional) avisa al padre para que
// el punto decorativo de la barra de tabs (NoveltyTabDot) se actualice ya
// mismo en vez de esperar al próximo render por otra causa.
export default function NoveltyInfoButton({ anchors, noveltyWindowDays, onSeen }) {
  const [open, setOpen] = useState(false);
  const entrada = resolveNoveltyEntry(anchors, noveltyWindowDays);

  if (!entrada) return null;

  function abrir() {
    setOpen(true);
    markSeen(entrada.id);
    if (onSeen) onSeen(entrada);
  }

  return (
    <>
      <Tooltip title={`Novedad: ${entrada.title}`}>
        <IconButton onClick={abrir} aria-label={`Novedad: ${entrada.title}`}>
          <FiberNewIcon color="error" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Chip
            size="small"
            label={TIPO_LABEL[entrada.type] || entrada.type}
            color={TIPO_COLOR[entrada.type]}
            style={{ marginBottom: 8 }}
          />
          <Typography variant="h6">{entrada.title}</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            {entrada.summary}
          </Typography>
          {entrada.howTo && entrada.howTo.length > 0 && (
            <Box mt={2}>
              <Typography variant="subtitle2" gutterBottom>
                Cómo usarlo
              </Typography>
              <ol style={{ paddingLeft: 20, margin: 0 }}>
                {entrada.howTo.map((paso, i) => (
                  <li key={i}>
                    <Typography variant="body2">{paso}</Typography>
                  </li>
                ))}
              </ol>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            component={RouterLink}
            to={`/novedades#${entrada.id}`}
            onClick={() => setOpen(false)}
          >
            Ver en el changelog
          </Button>
          <Button onClick={() => setOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

NoveltyInfoButton.propTypes = {
  anchors: PropTypes.arrayOf(PropTypes.string).isRequired,
  noveltyWindowDays: PropTypes.number,
  onSeen: PropTypes.func,
};
